module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "d-table"
  }, [_c('thead', [_c('th', {
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.user.vName) + "\n  ")])]), _vm._v(" "), _c('tbody', [(_vm.user.vFag.length > 0) ? _c('tr', {
    staticClass: "tr__header"
  }, [_c('td', [_vm._v("Fag")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("Lærerklokketimer")]), _vm._v(" "), _c('td', {
    staticClass: "klokketime-td"
  }, [_vm._v("Lærerklokketimer type")])]) : _vm._e(), _vm._v(" "), (_vm.user.vFag.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-explainer",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("\n      Brugeren har ingen fag\n    ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.user.vFag), function(fag) {
    return _c('tr', [_c('td', [_c('div', {
      staticClass: "subject"
    }, [_vm._v("\n        " + _vm._s(fag.fag_navn) + " (" + _vm._s(fag.klasse_klokketimer) + ")\n      ")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "100%"
      }
    }, [_vm._v("\n      " + _vm._s(fag.klassebetegnelse) + "\n    ")]), _vm._v(" "), _c('td', [_c('input', {
      staticClass: "d-input__small",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": fag.learer_klokketimer
      },
      on: {
        "focus": function($event) {
          return $event.target.select()
        },
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.updateStilKlasseFagLaerer(_vm.user, fag, 'klokketimer', $event.target.value, $event.target)
        },
        "blur": function($event) {
          return _vm.updateStilKlasseFagLaerer(_vm.user, fag, 'klokketimer', $event.target.value, $event.target)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('select', {
      staticClass: "d-select__small",
      domProps: {
        "value": fag.klokketimer_type
      },
      on: {
        "change": function($event) {
          return _vm.updateStilKlasseFagLaerer(_vm.user, fag, 'klokketimer_type', $event.target.value)
        }
      }
    }, _vm._l((_vm.klokketimetyper), function(type, key) {
      return _c('option', {
        domProps: {
          "value": key
        }
      }, [_vm._v(_vm._s(type))])
    }), 0)])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ade1de9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/KompetenceIndberetning/KompetenceIndberetningDaekningUser.vue
// module id = 1784
// module chunks = 1